module.exports = __webpack_public_path__ + "static/media/contact-bg.1a05c427.jpg";